// extracted by mini-css-extract-plugin
export default {"printPage":"Index_printPage__CLL9x","printArea":"Index_printArea__oo7aU"};